import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 7v11.011A4 4 0 0115.66 17H19V5h-3a3 3 0 00-2.4 1.2L13 7zm-2 11.011A4 4 0 008.34 17H5V5h3a3 3 0 012.4 1.2l.6.8v11.011zm3.24 1.579a2 2 0 011.42-.59H20a1 1 0 001-1V4a1 1 0 00-1-1h-4a4.999 4.999 0 00-4 2 4.998 4.998 0 00-4-2H4a1 1 0 00-1 1v14a1 1 0 001 1h4.34a2 2 0 011.42.59l.83.82a2 2 0 002.82 0l.83-.82z",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
